import ComponentWithTooltip from './ComponentWithTooltip.component';

export default ComponentWithTooltip;